export class APIRequestURI {
  getBaseURI() {
    // return "https://acetechies-backend.onrender.com";
    return "https://acetechies-backend.vercel.app";
    // return "http://localhost:5000";
  }
  getBaseRedirectURL() {
    return "https://acetechs.in";
    // return "http://localhost:3000";
  }
}
